import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import Shuffle from 'shufflejs';
import {GalleryService} from '../../../providers/services/gallery.service';
import {Galleries} from '../../../../config/config';
import {map, take} from 'rxjs/operators';
import {UtilsService} from '../../../providers/services/utils.service';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-gallery-homepage',
  templateUrl: './gallery-homepage.component.html',
  styleUrls: ['./gallery-homepage.component.scss']
})
export class GalleryHomepageComponent implements OnInit, OnDestroy {

  @ViewChild('shuffleContainer', {static: true}) shuffleContainer: ElementRef;
  @ViewChild('shuffleSizer', {static: true}) shuffleSizer: ElementRef;
  public shuffleInstance: Shuffle;
  public readonly Shuffle = Shuffle;
  public readonly subscriptions = new Subscription();
  public categories;
  public items;


  constructor(private galleryService: GalleryService, private changeDetector: ChangeDetectorRef, private utilsService: UtilsService) {
    if (this.utilsService.isPlatformBrowser) {
      this.subscriptions.add(
        this.galleryService.getGallery(Galleries.Homepage)
          .pipe(
            map(res => res.body),
            take(1)
          )
          .subscribe(({data}) => {
            this.categories = data.categories;
            this.items = data.gallery.pictures;
            this.changeDetector.detectChanges();
            this.shuffleInstance = new Shuffle(this.shuffleContainer.nativeElement, {
              itemSelector: '.picture-item',
              sizer: this.shuffleSizer.nativeElement
            });
          })
      );
    }
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
